



import MagazinesListComponent from "@/components/admin/magazines/magazinesListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "MagazinesListPage",
  components: {
    MagazinesListComponent,
  },
})
export default class MagazinesListPage extends Vue {}
